var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"frame-stats",attrs:{"id":"news_frame","src":'https://broker.abybroker.it/ea2019/RicercaNotizie_NoBarre.aspx',"width":"100%","frameborder":"0","height":_vm.windowHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }